import moment from "moment-timezone";
/**
* Get a notification message based on the flight type
* @param {string} flightType - The type of flight (ARRIVAL or DEPARTURE)
* @returns {string} - The notification message
*/
export function generateMessageToNotify(flightType) {
    if (flightType === "ARRIVAL") {
        return "Pick-up date/time updated based on selected flight arrival.";
    } else if (flightType === "DEPARTURE") {
        return "Pick-up date updated based on selected flight departure.";
    }
    return "Pick-up date/time updated based on selected flight schedule.";
}

/**
 * Get the formatted pickup time in the specified timezone
 * @param {number} date - The date in Unix timestamp format
 * @param {string} timezone - The timezone to format the date in
 * @returns {string} - The formatted time string
 */
export function getPickupTime(date, timezone) {
    return moment
        .unix(date)
        .tz(timezone)
        .format("hh:mm A");
}

/**
 * Get the formatted pickup date in the specified timezone
 * @param {number} date - The date in Unix timestamp format
 * @param {string} timezone - The timezone to format the date in
 * @returns {string} - The formatted date string
 */
export function getPickupDate(date, timezone) {
    return moment
        .unix(date)
        .tz(timezone)
        .format("YYYY-MM-DD");
}
